var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
var NonEligibilityCriteriaAccordian = function (props) {
    var nonEligibilityProp = props.nonEligibilityProp, toggleAccordion = props.toggleAccordion;
    var _a = __read(useState('Show more'), 2), showText = _a[0], setShowText = _a[1];
    var handleToggle = function () {
        setShowText(showText === 'Show less' ? 'Show more' : 'Show less');
        toggleAccordion();
    };
    return (React.createElement("div", { className: 'lfc-text-xs lfc-pb-4 lfc-pl-4 lfc-flex lfc-justify-items-start' },
        React.createElement("p", { style: { paddingTop: '10px' }, className: 'lfc-text-sm lfc-pr-4' }, 'Why non-eligible:'),
        React.createElement("p", { className: 'w-[10px]' }),
        React.createElement(Accordion, { elevation: 0, sx: { border: 'none', backgroundColor: '#F8F8FF', width: 'max-content' }, className: '  lfc-rounded-md' },
            React.createElement(AccordionSummary, { onClick: handleToggle, "aria-controls": "panel1a-content", id: "panel1a-header", className: "".concat(showText === 'Show less' ? 'lfc-rounded-t-md' : 'lfc-rounded-md'), sx: {
                    backgroundColor: '#F5E2E2',
                    width: '100%',
                    '& .MuiAccordionSummary-content': { margin: '0px !important' },
                    padding: 0,
                    minHeight: 'fit-content !important',
                    '& .Mui-expanded': {}
                } },
                React.createElement("div", { className: 'lfc-flex lfc-flex-wrap lfc-justify-items-start lfc-items-center', style: { padding: '6px', width: '100%' } }, nonEligibilityProp === null || nonEligibilityProp === void 0 ? void 0 :
                    nonEligibilityProp.map(function (_a) {
                        var label = _a.label;
                        return (React.createElement(React.Fragment, null,
                            React.createElement("p", { className: 'lfc-text-center lfc-pb-0.5 lfc-px-2' }, label),
                            React.createElement("div", { style: {
                                    width: '5px',
                                    height: '5px',
                                    backgroundColor: 'brown',
                                    fontSize: '7px',
                                    borderRadius: '50%'
                                } })));
                    }),
                    React.createElement("p", { style: {
                            color: 'blue',
                            textDecoration: 'underline',
                            paddingLeft: '10px'
                        } },
                        showText,
                        " ",
                        showText === 'Show more' ? React.createElement(ExpandMoreIcon, null) : React.createElement(ExpandLessIcon, null),
                        ' '))),
            React.createElement(AccordionDetails, { className: "lfc-p-2", style: { display: 'flex', width: '100%' } },
                React.createElement("div", { style: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        paddingLeft: '5px'
                    } }, nonEligibilityProp === null || nonEligibilityProp === void 0 ? void 0 : nonEligibilityProp.map(function (_a) {
                    var label = _a.label, course = _a.course;
                    return (React.createElement("div", { className: 'lfc-flex lfc-mb-2', key: label },
                        React.createElement(CancelIcon, { sx: { color: '#B8B8B8' }, fontSize: 'small' }),
                        React.createElement("p", { style: { paddingLeft: '5px' } }, "".concat(label, " - ").concat(course || ''))));
                }))))));
};
export default NonEligibilityCriteriaAccordian;
//# sourceMappingURL=NonEligibilityCriteriaAccordian.js.map